// var rapHost = '//rap.qi-cloud.org/mockjsdata/183'
// var rapHost = "//146.40.141.192:8082/mockjsdata/218";
var rapHost = "";
var devImgHost = "//dummyimage.com";
var prodImgHost = "";
// /fep/pc
// 测试
var sftpConfig = {
    //host: '10.10.21.113',
    host: "146.40.141.195",
    port: 22,
    user: "root",
    pass: "qcloud",
    remotePath: "/opt/html-pc/giftcoupon",
    timeout: 20000,
};
// 正式
// var demoConfig = {
//     host: "39.108.95.152",
//     port: 63002,
//     user: "root",
//     pass: "Qi-cloud@3399366",
//     remotePath: "/opt/html/html-pc/zg",
//     timeout: 20000,
// };

var demoConfig = {
    host: "1.14.248.38",
    port: 63002,
    user: "root",
    pass: "Qi-cloud@3399366",
    remotePath: "/opt/html/html-pc/giftcoupon",
    timeout: 20000,
};

module.exports = {
    rapHost: "'" + rapHost + "'",
    devImgHost: "'" + devImgHost + "'",
    prodImgHost: "'" + prodImgHost + "'",
    sftpConfig: sftpConfig,
    demoConfig: demoConfig,
};
